export const BUCKET_URL =
  "https://elearning2d2c9c258725431dad74e726bbbe0390152556-dev.s3.eu-central-1.amazonaws.com/public/";

export const GET_FULL_URL = (s: string) => BUCKET_URL + s;
export const GET_KEY_FROM_URL = (s: string) => s.replace(BUCKET_URL, "");

export const DURATION_INTERVAL = 5000;
